import { parseId } from '../helpers/dataDictionary';

export const TYPES = {
  VARIABLE: 'variable',
};

export const initialState = {
  variablesIncluded: [],
  packageId: null,
  packageName: 'Untitled Enhancement Package',
  packageNameError: false,
  hasStateChanged: false,
  seedFileId: null,
  seedFileMatchedRecords: 0,
  price: 0,
  isSavedPackage: false,
};

export const RESET = 'reset';
export const ADD_VARIABLE = 'add-variable';
export const REMOVE_VARIABLE = 'remove-variable';
export const REMOVE_CATEGORY = 'remove-category';
export const PACKAGE_NAME_CHANGE = 'package-name-change';
export const LOAD_SAVED_PACKAGE = 'load-saved-package';
export const SET_SAVED_PACKAGE = 'set-saved-package';
export const SET_PACKAGE_NAME_ERROR = 'set-package-name-error';

export const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case ADD_VARIABLE: {
      const { id, key } = payload;

      return {
        ...state,
        variablesIncluded: [...state.variablesIncluded, { id, key }],
        hasStateChanged: true,
      };
    }
    case REMOVE_CATEGORY: {
      const { key: category } = payload;
      return {
        ...state,
        variablesIncluded: state.variablesIncluded.filter(({ id }) => {
          const idPath = parseId(id);
          return idPath[0] !== category;
        }),
        hasStateChanged: true,
      };
    }
    case REMOVE_VARIABLE: {
      const { id } = payload;
      return {
        ...state,
        variablesIncluded: state.variablesIncluded.filter(
          ({ id: existingId }) => existingId !== id
        ),
        hasStateChanged: true,
      };
    }
    case PACKAGE_NAME_CHANGE: {
      const { value } = payload;
      return {
        ...state,
        packageName: value,
      };
    }
    case LOAD_SAVED_PACKAGE: {
      const { packageId, packageName, variablesIncluded } = payload;
      return {
        ...state,
        packageId,
        packageName,
        variablesIncluded: variablesIncluded.map(({ id, key }) => ({
          id,
          key,
        })),
        hasStateChanged: false,
        isSavedPackage: true,
      };
    }
    case SET_SAVED_PACKAGE: {
      const { packageId, packageName } = payload;
      return {
        ...state,
        packageId,
        packageName,
        hasStateChanged: false,
        isSavedPackage: true,
      };
    }
    case SET_PACKAGE_NAME_ERROR: {
      const { packageNameError } = payload;
      return {
        ...state,
        packageNameError,
      };
    }
    case RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
